export const SECTION_HEADING_CLASS =
    "  xl:!leading-[54px] text-2xl lg:text-4xl font-semibold font-Poppins  text-Heading_Black text-center";
